<template>
  <div>
    <Head :title="`${form.name}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/clients">Клиенты</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }} {{ form.phone }}
    </h1>
    <trashed-message v-if="client.deleted_at" class="mb-6" @restore="restore"> Этот клиент был удален. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Имя" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Телефон" />
          <select-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2" label="Город">
            <option :value="null" />
            <option value="Самара">Самара</option>
            <option value="Тольятти">Тольятти</option>
            <option value="Б.Черниговка">Б.Черниговка</option>
          </select-input>
          <select-input v-model="form.gender" :error="form.errors.gender" class="pb-8 pr-6 w-full lg:w-1/2" label="Пол">
            <option :value="null" />
            <option value="Муж">Муж</option>
            <option value="Жен">Жен</option>
          </select-input>
          <select-input v-model="form.use_viber" :error="form.errors.use_viber" class="pb-8 pr-6 w-full lg:w-1/2" label="Использует viber">
            <option :value="null" />
            <option value="0">Нет</option>
            <option value="1">Да</option>
          </select-input>
          <select-input v-model="form.use_whatsapp" :error="form.errors.use_whatsapp" class="pb-8 pr-6 w-full lg:w-1/2" label="Использует Whatsapp">
            <option :value="null" />
            <option value="0">Нет</option>
            <option value="1">Да</option>
          </select-input>
<!--          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />-->
<!--          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Адрес" />-->
          <text-input v-model="form.deny_counter" :error="form.errors.deny_counter" class="pb-8 pr-6 w-full lg:w-1/2" label="Счетчик отказов" />
          <select-input v-model="form.phone_confirmed" :error="form.errors.phone_confirmed" class="pb-8 pr-6 w-full lg:w-1/2" label="Телефон подвержден">
            <option value="0">Нет</option>
            <option value="1">Да</option>
          </select-input>
          <text-input v-model="form.deposit" :error="form.errors.deposit" class="pb-8 pr-6 w-1/2" label="Депозит (руб.)" />
          <div class="w-1/2"><Link class="text-indigo-400 hover:text-indigo-600" :href="`/clients/${client.id}/deposit`">История депозита</Link></div>
          <text-input v-model="form.discount" :error="form.errors.discount" class="pb-8 pr-6 w-full" label="Скидка (руб.)" />
          <text-input v-model="form.discount_until" :error="form.errors.discount_until" class="pb-8 pr-6 w-full lg:w-1/2" label="Скидка действует до" />
          <text-input v-model="form.discount_left" :error="form.errors.discount_left" class="pb-8 pr-6 w-full lg:w-1/2" label="Скидка действует раз" />
          <textarea-input v-model="form.comments" :error="form.errors.comments" class="pb-8 pr-6 w-full" style="min-height: 150px;" label="Комментарии (видны только оператору)" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!client.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Удалить клиента</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Сохранить клиента</loading-button>
        </div>
      </form>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <div class="mb-2 w-full">
          <strong>Создан: </strong>{{ client.created_at }}
        </div>
        <div class="mb-8 w-full">
          <strong>Пользователь телеграм бота:</strong>
          <span v-if="!client.telegraph_chat"> не подключен. ПИН: <strong>{{ client.pin_code }}</strong></span>
          <span v-if="client.telegraph_chat"> c {{ client.telegraph_chat.created_at }}, {{ client.telegraph_chat.name }}</span>
          <button v-if="client.telegraph_chat" class="text-red-600 hover:underline; pl-4" tabindex="-1" type="button" @click="unlink">Отвязать</button>
        </div>
      </div>
    </div>
    <h1 v-if="awaits.length > 0" class="mb-8 mt-5 text-3xl font-bold">
      Текущий лист ожидания
    </h1>
    <div v-if="awaits.length > 0" class="bg-white rounded-md shadow overflow-x-auto mt-8">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Время записи</th>
          <th class="pb-4 pt-6 px-6">Точка</th>
          <th class="pb-4 pt-6 px-6">Инициатор записи</th>
          <th class="pb-4 pt-6 px-6">Комментарии</th>
        </tr>
        <tr v-for="awaitingClient in awaits" :key="awaitingClient.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t px-6">
            {{ new Date(awaitingClient.pivot.created_at).toLocaleString('ru-RU') }}
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/trips/${awaitingClient.pivot.trip_id}/awaits/${awaitingClient.pivot.client_id}/edit`">
              {{ awaitingClient.pivot.point_name }} ({{ awaitingClient.pivot.point_time }}мин)
            </Link>
          </td>
          <td class="px-6 border-t">
            {{ awaitingClient.pivot.added_by }}
          </td>
          <td class="px-6 border-t">
            {{ awaitingClient.pivot.comment }}
          </td>
        </tr>
      </table>
    </div>
    <h1 class="mb-8 mt-4 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" :href="`/clients/${client.id}/edit`">Поездки</Link> клиента (всего: {{ trips.length }})
      <Link class="text-indigo-400 hover:text-indigo-600" href="./?cancels" :only="['tripCancels']">Отмены</Link> клиента (всего: {{ client.trip_cancels }})
    </h1>
    <div v-if="tripCancels" class="bg-white rounded-md shadow overflow-x-auto mt-8">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Поездка</th>
          <th class="pb-4 pt-6 px-6">Дата поездки</th>
          <th class="pb-4 pt-6 px-6">Маршрут</th>
          <th class="pb-4 pt-6 px-6">Время отмены</th>
          <th class="pb-4 pt-6 px-6">Инициатор отмены</th>
          <th class="pb-4 pt-6 px-6">Время до начала поездки</th>
        </tr>
        <tr v-for="tripCancel in tripCancels" :key="tripCancel.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/trips/${tripCancel.trip_id}/edit`">
              #{{ tripCancel.trip_id }}
            </Link>
          </td>
          <td class="border-t px-6">
            {{ tripCancel.trip_date }}
          </td>
          <td class="border-t px-6">
            {{ tripCancel.route_name }}
          </td>
          <td class="border-t px-6">
            {{ tripCancel.date }}
          </td>
          <td class="px-6 border-t">
            {{ tripCancel.user }}
          </td>
          <td class="border-t px-6">
            {{ tripCancel.time_before_start }}
          </td>
        </tr>
        <tr v-if="tripCancels.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">У клиента не было отмен</td>
        </tr>
      </table>
    </div>
    <div v-if="!client.show_cancels" class="bg-white rounded-md shadow overflow-x-auto mt-8">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Поездка</th>
          <th class="pb-4 pt-6 px-6">Дата</th>
          <th class="pb-4 pt-6 px-6">Маршрут</th>
          <th class="pb-4 pt-6 px-6">Водитель</th>
          <th class="pb-4 pt-6 px-6" />
        </tr>
        <tr v-for="trip in trips" :key="trip.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/trips/${trip.id}/clients/${client.id}/edit`">
              #{{ trip.id }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/trips/${trip.id}/clients/${client.id}/edit`">
              {{ trip.trip_date }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/trips/${trip.id}/clients/${client.id}/edit`">
              {{ trip.name }}
            </Link>
          </td>
          <td class="w-px border-t">
            {{ trip.first_name }}
          </td>
        </tr>
        <tr v-if="trips.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">У клиента не было поездок</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  components: {
    TextareaInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    client: Object,
    trips: Array,
    awaits: Array,
    tripCancels: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.client.name,
        email: this.client.email,
        gender: this.client.gender,
        phone: this.client.phone,
        phone_confirmed: this.client.phone_confirmed,
        address: this.client.address,
        comments: this.client.comments,
        city: this.client.city,
        use_viber: this.client.use_viber,
        use_whatsapp: this.client.use_whatsapp,
        deny_counter: this.client.deny_counter,
        discount: this.client.discount,
        deposit: this.client.deposit,
        discount_until: this.client.discount_until,
        discount_left: this.client.discount_left,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/clients/${this.client.id}`)
    },
    destroy() {
      if (confirm('Вы уверены что хотите удалить клиента?')) {
        this.$inertia.delete(`/clients/${this.client.id}`)
      }
    },
    restore() {
      if (confirm('Вы уверены что хотите восстановить клиента?')) {
        this.$inertia.put(`/clients/${this.client.id}/restore`)
      }
    },
    unlink() {
      if (confirm('Вы уверены что хотите отвязать клиента от телеграм бота? После этого появится новый пин-код который можно будет использовать для повторной привязки')) {
        this.$inertia.put(`/clients/${this.client.id}/unlink`)
      }
    },
  },
}
</script>
